
import React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

const StudentsLoading = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {[...Array(6)].map((_, index) => (
        <Card key={index} className="animate-pulse">
          <CardHeader className="bg-slate-200 dark:bg-nalc-dark/40 h-24"></CardHeader>
          <CardContent className="py-6">
            <div className="h-4 bg-slate-200 dark:bg-nalc-dark/40 rounded mb-4 w-3/4"></div>
            <div className="h-4 bg-slate-200 dark:bg-nalc-dark/40 rounded mb-2 w-1/2"></div>
            <div className="h-4 bg-slate-200 dark:bg-nalc-dark/40 rounded w-1/3"></div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default StudentsLoading;
